<div class="row justify-content-center">
  <div class="col-lg-10">
    <div class="block border my-2">
      <div class="border-bottom p-2">
        <table class="table table-striped table-hover my-0">
          <thead>
          <tr>
            <th scope="col" class="d-lg-table-cell d-none">Icon</th>
            <th scope="col">Symbol</th>
            <th scope="col" class="d-lg-table-cell d-none">Name</th>
            <th scope="col" class="d-lg-table-cell d-none">Decimal</th>
            <th scope="col">Contract address</th>
            <th scope="col" class="d-lg-table-cell d-none">Description</th>
            <th scope="col">Network (Chain)</th>
            <th scope="col">Exchange</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let token of tokenService.getTokens()">
            <th scope="row" class="d-lg-table-cell d-none">{{ token.icon }}</th>
            <td>{{ token.symbol }}</td>
            <td class="d-lg-table-cell d-none">{{ token.name }}</td>
            <td class="d-lg-table-cell d-none">{{ token.decimal }}</td>
            <td>{{ token.contract }}</td>
            <td class="d-lg-table-cell d-none">{{ token.description }}</td>
            <td>{{ getInstance(token.network_id, this.networkService.getNetworks()).name }}</td>
            <td>{{ getInstance(token.exchange_id, this.exchangeService.getExchanges()).name }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
